import { render, staticRenderFns } from "./edit-content.vue?vue&type=template&id=fba5d962&"
import script from "./edit-content.vue?vue&type=script&lang=js&"
export * from "./edit-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports